module.exports = __webpack_public_path__ + "media/images/flags/sr-48ef992b39b30027658ff5603c96acb3.svg";